import chevron from "@/img/chevron-right.svg";
import ButtonContainer from "@/components/button-container/ButtonContainer";
import { Button } from "@wordpress/components";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

export const ShowTenForecast = () => {
	const { t } = useTranslation();
	const lang = getCurrentLanguage();

	return (
		<ButtonContainer
			href={`${lang}/weather-forecast`}
			content={
				<Button>
					{t("tenDayForecast")}
					<img src={chevron} alt="chevron" />
				</Button>
			}
		></ButtonContainer>
	);
};

export default ShowTenForecast;
